<template>
    <application-layout>
        <v-main>
            <v-form
              ref="createFacilityForm"
              @submit.prevent="submitFacilityForm"
            >
                <v-container fluid>
                    <h1>Add New Facility</h1>

                    <hr>

                    <facility-basics />
                    <location-details />
                    <facility-hours />
                    <website-options />

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                data-testid="facility-create-cancel-btn"
                                class="facility-create-cancel-btn mr-3 ml-0"
                                @click="handleCancelCreateFacility"
                                color="error"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                data-testid="facility-create-save-btn"
                                class="facility-create-save-btn"
                                color="primary"
                                type="submit"
                                :loading="loading"
                                :disabled="loading"
                            >
                                Save
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-main>
    </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import FacilityBasics from "@/views/facility/partials/FacilityBasics.vue";
import FacilityHours from "@/views/facility/partials/FacilityHours.vue";
import LocationDetails from "@/views/facility/partials/FacilityDetails.vue";
import WebsiteOptions from "@/views/facility/partials/WebsiteOptions.vue";

export default {
  data() {
    return {
      loading: false
    };
  },

  computed: {
    createFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  },

  methods: {
    async handleCancelCreateFacility() {
      await this.$store.commit("resetCurrentFacility");
      this.$router.back();
    },
    submitFacilityForm() {
      if (this.$refs.createFacilityForm.validate()) {
        this.loading = true;
        this.$store.dispatch("createFacility")
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },

  components: {
    ApplicationLayout,
    FacilityBasics,
    LocationDetails,
    FacilityHours,
    WebsiteOptions
  }
};
</script>
